<template>
    <b-table-simple responsive bordered>
        <b-thead>
            <b-tr>
                <b-th>CODE</b-th>
                <b-th>Description</b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <b-tr v-for="(item, index) in tableData" :key="index">
                <b-td>{{ item.code }}</b-td>
                <b-td>{{ item.description }}</b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>
<script>
export default {
    data() {
        return {
            tableData: [
                {
                    code: 'LT1',
                    description: 'Lead Commission'
                },
                {
                    code: 'LT2',
                    description: 'Title Overriding Level 1'
                },
                {
                    code: 'LT3',
                    description: 'Title Overriding Level 2'
                },
                {
                    code: 'LR1',
                    description: 'Lead Recruit Level 1'
                },
                {
                    code: 'LR2',
                    description: 'Lead Recruit Level 2'
                },
                {
                    code: 'LR3',
                    description: 'Lead Recruit Level 3'
                },
                {
                    code: 'FSM',
                    description: 'Financial Support Manager'
                },
                {
                    code: 'FA',
                    description: 'Financial Advisor'
                },
                {
                    code: 'FAM',
                    description: 'Financial Advisor Manager'
                },
                {
                    code: 'FSD',
                    description: 'Financial Sales Director'
                },
                {
                    code: 'ASR1',
                    description: 'Advisor Service Recruit Level 1'
                },
                {
                    code: 'ASR2',
                    description: 'Advisor Service Recruit Level 2'
                },
                {
                    code: 'ASR3',
                    description: 'Advisor Service Recruit Level 3'
                }
            ]
        }
    }
}
</script>